import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../../../utils/LStrings';
import {
    map,
} from 'lodash';
import TablePlain from '../../../../../../../components/table-plain/TablePlain';
import TableUtils from '../../../../../../../utils/TableUtils';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class TableAutonomoMonotributista extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data.datos)
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data.datos)
		});
	}

	/**
	 * Proceso la información de Autónomo Monotributista
	 * Actualmente no hace nada, se utiliza la estructura para compatibilidad
	 */
	processData = (data) => {
		return data;
	}

    render() {
		return (
			<TablePlain
				fixed={true}
				columns={[
					lstrings.periodo,
					lstrings.tipo,
					lstrings.categoria,
					lstrings.ganancias,
					lstrings.iva,
					lstrings.integrasociedades
				]}
				columnsWidth={[
					'',
					'25%',
					'',
					'',
					'',
					'',
				]}
				rows={map(this.state.data, (item, ix) =>
					<tr key={ix}>
						<td>{TableUtils.dateFormat(item.fechaInicio)} - {TableUtils.dateFormat(item.fechaHasta)}</td>
						<td>{item.tipo}</td>
						<td>{item.categoria}</td>
						<td>{item.ganancias}</td>
						<td>{item.iva}</td>
						<td>{item.integrasociedades}</td>
					</tr>)
				}
			/>
        );
	}
}

TableAutonomoMonotributista.propTypes = {
    data: PropTypes.any,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default TableAutonomoMonotributista;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableAutonomoMonotributista.js